import { useMemo } from 'react';
import { isDentistUser } from '../utilities/dentistPortal';
import { useCrudAccess, usePageAccess } from './usePageAccess';

export function useEntityLinks() {
  const { hasPage, user } = usePageAccess();
  const isDentist = isDentistUser(user);
  const clients = useCrudAccess('clients');
  const dentists = useCrudAccess('dentists');
  const orders = useCrudAccess('orders');
  const invoices = useCrudAccess('invoices');
  const users = useCrudAccess('users');
  const expenses = useCrudAccess('expenses');

  return useMemo(
    () => ({
      canOpenClient: !isDentist && (clients.canList || clients.canView),
      canOpenDentist: !isDentist && (dentists.canList || dentists.canView || clients.canList || clients.canView),
      canOpenOrder: orders.canList || orders.canView,
      canOpenInvoice: invoices.canList || invoices.canView,
      canOpenUser: users.canList || users.canView,
      canOpenWallet: !isDentist && (hasPage('wallets') || hasPage('wallets.view')),
      canOpenExpense: expenses.canList || expenses.canView,
    }),
    [
      isDentist,
      clients.canList,
      clients.canView,
      dentists.canList,
      dentists.canView,
      orders.canList,
      orders.canView,
      invoices.canList,
      invoices.canView,
      users.canList,
      users.canView,
      expenses.canList,
      expenses.canView,
      hasPage,
    ]
  );
}
